import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { StringHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/StringHelper";
import { PropertyChange } from "@seriously-rad/seriouslyrad-framework-core/PropertyChange";
import { InputControl, InputControlPropertyValues } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/InputControl";
import { ElementRef } from "@seriously-rad/seriouslyrad-framework-core/Ui/ElementRef";
import { JsxFragment } from "@seriously-rad/seriouslyrad-framework-core/Ui/JsxFragment";

import "./HtmlViewer.scss";

export class HtmlViewer extends InputControl
{
    protected htmlContainerRef?: ElementRef;

    constructor(propertyValues?: PartialNullable<InputControlPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("gme-control-html-viewer");
    }

    protected override __initializeProperties(propertyValues: InputControlPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.htmlContainerRef = new ElementRef();
    }

    protected override _createElementHtml(children?: JsxFragment | string | (JsxFragment | string | undefined)[]): JsxFragment
    {
        return (
            <div>
                <div ref={this.htmlContainerRef} class="html-container">
                    {children}
                </div>
            </div>
        );
    }
    protected override _valueChanged(change: PropertyChange<any>)
    {
        super._valueChanged(change);

        let
            currentValue = change.currentValue;

        if (typeof currentValue === "string")
            currentValue = StringHelper.removeScriptTags(currentValue);

        this.htmlContainerRef?.current.html(currentValue);
    }
}
